import { ApiRequest } from '../../../../common/api/request';
import _ from 'lodash';

export class InboxIbanService extends ApiRequest {
  constructor($http, $q, appConfig) {
    'ngInject';
    super({ $http, $q, appConfig });
  }

  get apiPath() {
    return '/api/v0/aid/courier';
  }

  find(q, tenant, type, limit = 10) {
    return this.$http({
      method: 'GET',
      url: `${this.apiPath}/search`,
      params: {
        q, // query iban
        tenant,
        type, // oldIban or newIban
        limit,
      },
    }).then((result) => {
      return result;
    });
  }

  removePrefixFromValue(prefix, value) {
    value = value && _.isString(value) && value.toUpperCase();
    if (prefix && value && value.indexOf(prefix) === 0) {
      return value.replace(new RegExp('^' + prefix), '');
    }
    return value;
  }
}
